import * as React from "react";
import { useInterpolatedString } from "./toucan/src/interpolate";
import InterfaceManager from "./toucan/src/interfaces/manager";
import { useTranslation } from "react-i18next";

import { Text, Stack } from "@smartphoneorchestra/components";
import { Screen, TruthAnalyticsLogo } from "./Styles/StyleComponents";

interface TheCharmProps {
  text: string;
}

const TheCharm = (props: TheCharmProps) => {
  const { t } = useTranslation("thecircleoftruth");
  const transText = t(props.text);
  const text = useInterpolatedString(transText);

  React.useEffect(() => {
    InterfaceManager.notifyComponentChanged("text");
  }, [text]);

  return (
    <Screen align="center" color="pink">
      <TruthAnalyticsLogo width="50%" />
      <Stack grow justify="center">
        <Text as="blockquote" center size="5">
          “ I
          <br />
          AM
          <br />
          READY “
        </Text>
      </Stack>
    </Screen>
  );
};

export default TheCharm;
